import { render, staticRenderFns } from "./PropostasContencioso.vue?vue&type=template&id=646af79d&scoped=true"
import script from "./PropostasContencioso.vue?vue&type=script&lang=js"
export * from "./PropostasContencioso.vue?vue&type=script&lang=js"
import style0 from "./PropostasContencioso.vue?vue&type=style&index=0&id=646af79d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "646af79d",
  null
  
)

export default component.exports